import { Container } from "pixi.js";
import type { GameTransitionPort } from "@slot/game-shell";
import type { BonusTransition } from "./BonusTransition";

/**
 * The base ⇄ bonus transition overlay behind `GameTransitionPort`, over every panel. The way in is the artist's potion
 * explosion (`BonusTransition`): the shell plays the transition as the HOLD & WIN card is dismissed, the card goes once
 * the explosion covers the screen, and the round goes into the bonus under it. The way out has nothing to play (the
 * finished panel carries the moment, and the grid stays on screen into the base game), so it resolves at once; the
 * shell's presenter still shows and hides the root and fires its cue.
 */
export class GameTransitionView extends Container implements GameTransitionPort {
  private readonly transition: BonusTransition;
  private readonly entering: () => boolean;

  /** `entering`: whether this transition is the way in (the HOLD & WIN card is on screen as it is dismissed). */
  public constructor(input: { transition: BonusTransition; entering: () => boolean }) {
    super({ label: "GameTransitionPanel" });
    this.visible = false;
    this.transition = input.transition;
    this.entering = input.entering;
    this.addChild(input.transition);
  }

  public show(): void {
    this.visible = true;
  }

  public hide(): void {
    this.visible = false;
  }

  /** The way in plays the potion explosion and resolves once it is over; the way out resolves at once. */
  public playTransition(): Promise<void> {
    return this.entering() ? this.transition.play() : Promise.resolve();
  }
}
